export default "__VITE_ASSET__B8FD3XD6__"